export const TABLE_ANALYTIC_AWARD = {
    column: [
        {
            name: 'Nama',
            key: 'name',
        },
        {
            name: 'Total Vote',
            key: 'total',
        },
        {
            name: '% Vote',
            key: 'percentage',
        },
    ],
}
